module.exports = __webpack_public_path__ + "static/media/news-03.1a649c41.jpg";